"use strict";
var ng2_tab_component_1 = require("./ng2-tab.component");
exports.Ng2TabComponent = ng2_tab_component_1.Ng2TabComponent;
var ng2_tab_module_1 = require("./ng2-tab.module");
exports.Ng2TabModule = ng2_tab_module_1.Ng2TabModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-tab/dist/index.js
// module id = 89
// module chunks = 0